<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">备案</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">我的分享</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">我的分享</div>
      </div>
      <div class="panel-body">
        <div class="ub-box" v-loading="listLoading">
          <div v-if="hasMubu === 'have'" class="ub-box">
            <div class="share-left">
              <el-form label-width="92px" class="beian-ruleForm">
                <el-form-item label="所在地区：">
                  {{cityInfo.city}} {{cityInfo.area}}
                </el-form-item>
                <el-form-item label="详细地址：" prop="address">
                  {{address}}
                </el-form-item>
                <el-form-item label="单位名称：" prop="company">
                  {{c_name}}
                </el-form-item>
                <el-form-item label="工作时间：" prop="time">
                  {{work_time}}
                </el-form-item>
                <el-form-item label="联系人：" prop="linkman">
                  {{linkman}}
                </el-form-item>
                <el-form-item label="手机号：" prop="tel">
                  {{mobile}}
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                  {{remark}}
                </el-form-item>
                <el-form-item label="审核状态：" prop="state">
                  {{state}}
                </el-form-item>
                <el-form-item label="开放状态：" prop="is_open">
                  {{is_open}}
                </el-form-item>
              </el-form>
            </div>
            <div class="ub-box z-margin-left-50-precent z-font-size-14">
              <img :src="c_img" class="col-img"/>
            </div>
          </div>
          <div v-if="hasMubu === 'none'" class="ub-box ub-ver-h z-width-100-precent z-textAlign-center">
            <div class="z-margin-bottom-50-precent">
              <img src="../../assets/imgs/no_mubu.png" alt="没有幕布">
              <br>
              <br>
              <span class="z-font-size-18">您还没有分享幕布</span>
              <br>
              <br>
              <span class="z-font-size-14">觉得幕布使用一次闲置很浪费，快来参与阿贝云幕布分享计划吧，为您周围</span>
              <br>
              <br>
              <span class="z-font-size-14">需要备案的朋友提供拍照便利。在
                <router-link to="beian3" class="z-font-size-14 z-color-a">快递材料</router-link>
                里分享您购买的幕布。</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import beianService from 'business/beianService.js'
  import userService from 'business/userService.js'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data() {
      return {
        listLoading:false,
        hasMubu:'',
        cityInfo: {
          province:'',
          city:'',
          area:''
        },
        address:'',
        c_name:'',
        work_time:'',
        linkman:'',
        mobile:'',
        remark:'',
        state:'',
        is_open:'',
        c_img:''
      }
    },
    components:{

    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.config()
    },
    methods:{
      ...mapActions(['SETTHREE_MENU']),
      async config() {
        await this.getArea()
        this.ShareInfo()
      },
      async ShareInfo() {
        let {vueData, state} = await beianService.transformToVue('beianKuaidi','POST','cmd=my_fenxiang')
        if(vueData.response == 200 ) {
          if(vueData.msg[0].address){
            this.hasMubu = 'have'
            let data = vueData.msg[0]
            this.address = data.address
            this.c_name = data.c_name
            this.work_time = data.work_time
            this.linkman = data.linkman
            this.mobile = data.mobile
            this.remark = data.remark
            this.c_img = data.c_img
            for(let i in this.DISTRICTS){
              if(this.DISTRICTS[i].area_id == 0){
                this.cityInfo.province = this.DISTRICTS[i].area_title
                let province = this.DISTRICTS[i].province
                for(let j in province){
                  if(province[j].area_id == data.province_id){
                    this.cityInfo.city = province[j].area_title
                    let city = province[j].city
                    for(let k in city){
                      if(city[k].area_id == data.city_id){
                        this.cityInfo.area = city[k].area_title
                      }
                    }
                  }
                }
              }
            }
          }else{
            this.hasMubu = 'none'
          }
          switch (vueData.msg[0].state) {
            case '0':
              this.state = '待审核'
              break
            case '1':
              this.state = '审核通过'
              break
            case '2':
              this.state = '审核失败'
              break
          }
          switch (vueData.msg[0].is_open) {
            case '0':
              this.is_open = '关闭'
              break
            case '1':
              this.is_open = '开放'
              break
          }
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async getArea() {
        this.listLoading = true
        let {vueData, state} = await userService.transformToVue('userInfo','POST','cmd=area_dic')
        if(state.code === '000' ) {
          this.DISTRICTS = vueData
        }else {
          this.$toast('请刷新页面...','fail')
        }
      },
    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
  .col-img {
    height: 430px;
    width: auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/beian/beian10.vue